// Install: npm install react-color
import React, { useState, useEffect } from "react";
import { SketchPicker } from "react-color";
import "./TeamColorPicker.css"; // For styling the expanded picker

function TeamColorPicker({
  initialColor,
  onColorChange,
  label = "Team Color",
}) {
  // Local state to manage the color object received from the picker
  const [colorState, setColorState] = useState({ hex: initialColor });

  // Update local state when initialColor prop changes (e.g., for editing existing teams)
  useEffect(() => {
    setColorState({ hex: initialColor });
  }, [initialColor]);

  // Handler for when the color changes (on drag or value input)
  const handleChange = (color) => {
    // 1. Update the local state with the full color object (for the picker UI)
    setColorState(color);

    // 2. ONLY pass the HEX value back to the parent component (and ultimately, the form state)
    // This is the CRITICAL step for saving only HEX.
    onColorChange(color.hex);
  };

  return (
    <div className="team-color-picker-wrapper">
      <label className="modal-form-label">{label}</label>

      {/* SketchPicker shows the full interface */}
      <SketchPicker
        color={colorState.hex} // Use the hex string for the picker's current value
        onChange={handleChange} // Call our custom handler
        disableAlpha={true} // Usually alpha isn't needed for team colors
      />

      {/* Display the final HEX value below the picker */}
      <div className="current-hex-display">
        Selected HEX: <strong>{colorState.hex.toUpperCase()}</strong>
      </div>
    </div>
  );
}

export default TeamColorPicker;




// // Install: npm install react-color
// import React, { useState, useEffect } from "react";
// // 1. Change the import from SketchPicker to MaterialPicker
// import { MaterialPicker } from "react-color";
// import "./TeamColorPicker.css"; // For styling the expanded picker

// function TeamColorPicker({
//   initialColor,
//   onColorChange,
//   label = "Team Color",
// }) {
//   // Local state to manage the color object received from the picker
//   const [colorState, setColorState] = useState({ hex: initialColor });

//   // Update local state when initialColor prop changes (e.g., for editing existing teams)
//   useEffect(() => {
//     // Note: MaterialPicker can sometimes be sensitive to initial color formatting,
//     // so providing a clear hex string is best.
//     setColorState({ hex: initialColor });
//   }, [initialColor]);

//   // Handler for when the color changes (on drag or value input)
//   const handleChange = (color) => {
//     // 1. Update the local state with the full color object (for the picker UI)
//     // The MaterialPicker returns a color object with 'hex', 'rgb', and 'hsl'
//     setColorState(color);

//     // 2. ONLY pass the HEX value back to the parent component (CRITICAL step for saving only HEX)
//     onColorChange(color.hex);
//   };

//   return (
//     <div className="team-color-picker-wrapper">
//       <label className="modal-form-label">{label}</label>

//       {/* 2. Use MaterialPicker instead of SketchPicker */}
//       <MaterialPicker
//         color={colorState.hex} // Use the hex string for the picker's current value
//         onChange={handleChange} // Call our custom handler
//         // MaterialPicker does not have a disableAlpha prop, so it's omitted.
//       />

//       {/* Display the final HEX value below the picker */}
//       <div className="current-hex-display">
//         Selected HEX: <strong>{colorState.hex.toUpperCase()}</strong>
//       </div>
//     </div>
//   );
// }

// export default TeamColorPicker;